module.exports = __webpack_public_path__ + "img/ic_signin.5e975d99.svg";